<div class="pink_box"></div>
<div class="green_box"></div>

<div class="main">
  <div class="reference_table">
    <div class="top">
      <button class="top_button" (click)="addCommunity()" *ngIf="status">
        Add<em class="ti-plus"></em> 
      </button>

      <div class="right_part">
        <button class="top_button">Filter<em class="ti-filter"></em> </button>
        <div class="search">
          <input
            id="nav_search"
            class="input is-medium"
            placeholder="Search for Local Govt."
            [formControl]="control"
            [appAutocomplete]="autocomplete"
          />
          <app-autocomplete #autocomplete="appAutocomplete">
            <ng-template appAutocompleteContent>
              <ng-container *ngIf="(lgas | filter: control.value) as result">
                <app-option
                  (click)="selectLga(option.id)"
                  *ngFor="let option of result"
                  [value]="option.LgaName"
                >
                  {{ option.LgaName }}
                </app-option>
                <app-option class="no-result" *ngIf="!result.length"
                  >No result...</app-option
                >
              </ng-container>
            </ng-template>
          </app-autocomplete>
          <span class="search_icon"
            ><img src="assets/images/top_nav/Magnifiction.svg" alt=""
          /></span>
        </div>
      </div>
    </div>

    <div class="custom_table_four_row" *ngIf="status">
      <form [formGroup]="communityForm">
        <div class="thead">
          <span class="head">S/N</span>
          <span class="head">Community Name</span>
          <span class="head">Serial No.</span>
          <span class="head">Action</span>
        </div>

        <div class="tbody" formArrayName="Communities">
          <div
            class="td"
            *ngFor="
              let community of communityForm.get('Communities')['controls'];
              index as i
            "
            [formGroupName]="i"
          >
            <span class="head">{{ i + 1 }}</span>
            <span
              ><input
                type="text"
                formControlName="CommunityName"
                placeholder="Enter  Community Name"
            /></span>
            <span
              ><input
                type="text"
                formControlName="SerialNo"
                placeholder="Enter Serial Number"
            /></span>
            <span
              ><button
                class="delete_icon trash"
                (click)="deleteCommunity(i, community.value)"
              >
                <em class="ti-trash"> </em> </button
            ></span>
          </div>
        </div>

        <div class="submit">
          <button class="submit_button" (click)="onSubmit(communityForm.value)">
            Submit
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
